import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from  "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Which Firebase project this build talks to (TESTING_PLAN.md §2.1, G3):
// - Production builds (`yarn build`, Azure) always use zeeno-robotics.
// - Everything else (`yarn start`, Jest) uses the local emulators of the
//   demo-zeeno project, unless REACT_APP_FIREBASE_TARGET=prod (`yarn start:prod`).
const isProductionBuild = process.env.NODE_ENV === "production";
const useProduction = isProductionBuild || process.env.REACT_APP_FIREBASE_TARGET === "prod";

const productionConfig = {
  apiKey: "AIzaSyADBftw3U_PRS-2PbWSQFxrT1B2GzVguug",
  authDomain: "zeeno-robotics.firebaseapp.com",
  projectId: "zeeno-robotics",
  storageBucket: "zeeno-robotics.firebasestorage.app",
  messagingSenderId: "758685974548",
  appId: "1:758685974548:web:b9faaf170c13dd653e2701"
};

// demo- projects have no real backend, so even a misrouted request can't
// reach production.
const emulatorConfig = {
  apiKey: "demo-api-key",
  authDomain: "demo-zeeno.firebaseapp.com",
  projectId: "demo-zeeno",
  storageBucket: "demo-zeeno.appspot.com",
};

const firebaseApp = initializeApp(useProduction ? productionConfig : emulatorConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

if (!useProduction) {
  // Set REACT_APP_FIREBASE_EMULATOR_HOST to this machine's LAN address to use
  // the emulators from a phone or tablet.
  const host = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || "127.0.0.1";
  connectFirestoreEmulator(db, host, 8080);
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  // There is no Storage emulator yet, so video and app-version uploads fail
  // locally (the demo-zeeno bucket doesn't exist).
} else if (!isProductionBuild) {
  console.warn("Firebase: development build connected to PRODUCTION (zeeno-robotics).");
}

export {auth};
export {db};
export {storage};
